import { reducer as adminInvoices } from "./Containers/AdminInvoicesPage/reducer"
import { reducer as adminUsers } from "./Containers/AdminUsersPage/reducer"
import { reducer as alerts } from "./Containers/AlertsPage/reducer"
import { reducer as balance } from "./Containers/Balance/reducer"
import { reducer as businessAccounts } from "./Containers/BusinessAccountsPage/reducer"
import { reducer as businessDetails } from "./Containers/BusinessDetailsBlock/reducer"
import { persistedReducer as credits } from "./Containers/CreditsPage/reducer"
import { reducer as dashboard } from "./Containers/DashboardPage/reducer"
import { reducer as globalFilters } from "./Containers/GlobalFilters/reducer"
import { persistedReducer as health } from "./Containers/Health/reducer"
import { persistedReducer as home } from "./Containers/HomePage/redux/home.slice"
import { reducer as invoices } from "./Containers/InvoiceHistoryBlock/reducer"
import { persistedReducer as auth } from "./Containers/LoginPage/redux/auth.slice"
import { reducer as marketing } from "./Containers/MarketingPage/reducer"
import { reducer as paymentMatching } from "./Containers/PaymentMatchingPage/reducer"
import { reducer as perksAdmin } from "./Containers/PerksAdminPage/reducer"
import { reducer as perks } from "./Containers/PerksPage/reducer"
import { reducer as publicApi } from "./Containers/PersonalSettings/PublicAPI/reducer"
import { reducer as pricing } from "./Containers/PricingPage/reducer"
import { persistedReducer as receiptBusiness } from "./Containers/ReceiptPage/ConfigureBusinessPage/redux/business.slice"
import { persistedReducer as receiptConfigure } from "./Containers/ReceiptPage/ConfigureProfilePage/redux/configure.slice"
import { persistedReducer as receipt } from "./Containers/ReceiptPage/redux/receipt.slice"
import { reducer as referrals } from "./Containers/Referrals/reducer"
import { reducer as requests } from "./Containers/RequestsPage/reducer"
// import { reducer as requestsDescriptors } from './Containers/RequestsPage/RequestsDescriptors/reducer';
import { reducer as requestsAutoRefund } from "./Containers/RequestsPage/RequestsAutoRefund/reducer"
import { reducer as requestsEnrollments } from "./Containers/RequestsPage/RequestsEnrollments/reducer"
import { reducer as requestsGifts } from "./Containers/RequestsPage/RequestsGifts/reducer"
import { reducer as requestsIntegrations } from "./Containers/RequestsPage/RequestsIntegrations/reducer"
import { reducer as requestsReceipts } from "./Containers/RequestsPage/RequestsReceipts/redux/requestsReceipts.slice"
import { persistedReducer as requestsVerifiInform } from "./Containers/RequestsPage/RequestsVerifiInform/reducer"
import { reducer as requestsWithdrawal } from "./Containers/RequestsPage/RequestsWithdrawal/reducer"
import { persistedReducer as setting } from "./Containers/Setting/redux/setting.slice"
//import { reducer as breadCrumbs } from './Containers/Breadcrumbs/actions';
import { reducer as shopifyMove } from "./Containers/ShopifyMove/redux/shopifyMove.slice"
import { persistedReducer as user } from "./Containers/User/redux/user.slice"
import { reducer as users } from "./Containers/UsersPage/reducer"
import { persistedReducer as nav } from "./Redux/nav/nav.slice"
import { persistedReducer as errors } from "./Redux/redux/errors.slice"

export const reducers = {
  auth,
  nav,
  errors,
  user,
  dashboard,
  alerts,
  home,
  //breadcrumbs: breadCrumbs,
  setting,
  shopifyMove,
  users,
  businessAccounts,
  adminUsers,
  requestsEnrollments,
  // requestsDescriptors,
  requestsAutoRefund,
  requestsIntegrations,
  requestsGifts,
  requestsWithdrawal,
  requestsReceipts,
  requestsVerifiInform,
  receipt,
  receiptConfigure,
  receiptBusiness,
  adminInvoices,
  pricing,
  invoices,
  globalFilters,
  credits,
  balance,
  marketing,
  requests,
  referrals,
  businessDetails,
  publicApi,
  health,
  perks,
  paymentMatching,
  perksAdmin
}

export default reducers
